import { faArrowRight, faCheckCircle, faEye, faEyeSlash, faArrowLeft, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import { SERVER_URL } from '../../config';
import toast from 'react-hot-toast';
import { useNavigate } from "react-router-dom";
import CountryList from '../../country.json'
import Select from 'react-select';
import GoogleTranslate from '../../GoogleTranslate';

export default function ClubSignup() {

    const countryOptions = CountryList.map(country => ({
        value: country.label,
        label: `${country.country_flag} ${country.label}`
    }));

    const [clubname, setClubname] = useState('');
    const [email, setEmail] = useState('');
    const [nationality, setNationality] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [otp, setOtp] = useState('');

    const [otpPopUp, setOtpPopUp] = useState(false);
    const [resendTimer, setResendTimer] = useState(60);
    const [isResendDisabled, setIsResendDisabled] = useState(true);
    const [errors, setErrors] = useState({});

    const [isSendingOTP, setIsSendingOTP] = useState(false);
    const [isVerifyingOTP, setIsVerifyingOTP] = useState(false);
    const [isResendingOTP, setIsResendingOTP] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        if (isResendDisabled) {
            const timer = setInterval(() => {
                setResendTimer((prev) => {
                    if (prev === 1) {
                        clearInterval(timer);
                        setIsResendDisabled(false);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
            return () => clearInterval(timer);
        }
    }, [isResendDisabled]);

    const handleResendOTP = async () => {
        setIsResendingOTP(true);
        setIsResendDisabled(true);
        await handleSendOTP();
        setIsResendingOTP(false);
    };

    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    const toggleConfirmPassword = () => {
        setShowConfirmPassword((prev) => !prev);
    }

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const handleConfirmPasswordChange = (e) => {
        setConfirmPassword(e.target.value);
    };

    const passwordsMatch = password === confirmPassword && password !== '';

    const handleSubmit = async () => {
        let response;
        try {

            const clubData = {
                club_name: clubname.trim(),
                nationality: nationality.trim(),
                email: email.trim(),
                password: password.trim()
            }

            response = await axios.post(`${SERVER_URL}/api/v2/club-signup`, clubData);
            if (response.data.status === true) {
                toast.success("Registered successfully!");
                setTimeout(() => {
                    navigate('/club/login');
                }, 3000);
            } else {
                toast.error(`${response.data.msg}`);
            }

        } catch (error) {
            console.error("Error during registering club : ", error);
            toast.error(`${error?.response?.data?.msg ?? error?.message}`);
        }
    };

    const handleSendOTP = async () => {
        setIsSendingOTP(true);

        let data = {
            "Club Name": clubname.trim(),
            "Nationality": nationality.trim(),
            "Email": email.trim(),
            "Password": password.trim()
        };

        const newErrors = {};
        if (!clubname.trim()) {
            newErrors.clubname = "Full name is required";
        } else {
            const nameRegex = /^[A-Za-z\s]{2,}$/;
            const onlyWhitespace = /^\s+$/;
            const hasNumbers = /\d/;
            if (onlyWhitespace.test(clubname)) {
                newErrors.clubname = "Full name cannot be only whitespace";
            } else if (hasNumbers.test(clubname)) {
                newErrors.clubname = "Full name cannot contain numbers";
            } else if (!nameRegex.test(clubname)) {
                newErrors.clubname = "Full name must be at least 2 characters";
            }
        }

        if (!nationality.trim()) newErrors.nationality = "Please select your nationality";

        if (!email.trim()) {
            newErrors.email = "Email is required";
        } else {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email.trim())) newErrors.email = "Invalid email format";
        }

        if (!password) {
            newErrors.password = "Password is required";
        } else {
            const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;
            if (!passwordRegex.test(password)) {
                newErrors.password = "Password must be at least 8 characters, with uppercase, lowercase, number, and special character";
            }
        }

        if (!confirmPassword) {
            newErrors.confirmPassword = "Please confirm your password";
        } else if (password && confirmPassword && password !== confirmPassword) {
            newErrors.confirmPassword = "Passwords do not match";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        setErrors({});

        const clubData = {
            club_name: clubname.trim(),
            nationality: nationality.trim(),
            email: email.trim(),
            password: password.trim()
        }

        try {
            const response = await axios.post(`${SERVER_URL}/api/v2/register-otp`, { email: email.trim(), role: "clubs" });
            if (response.data.status) {
                toast.success("OTP sent to your email!");
                setResendTimer(60);
                setOtpPopUp(true);
            } else {
                toast.error(response.data.msg || "Failed to send OTP.");
            }
        } catch (error) {
            console.error("Error sending OTP. Try again :", error);
            toast.error(error ? error?.response?.data?.msg : "Error sending OTP. Try again.");
        } finally {
            setIsSendingOTP(false);
        }
    };

    const handleVerifyOTP = async () => {
        if (!otp) {
            toast.error("Please enter the OTP.");
            return;
        }
        setIsVerifyingOTP(true);

        try {
            const response = await axios.post(`${SERVER_URL}/api/v2/verify-otp`, { email: email.trim(), otp, role: "clubs" });
            if (response.data.status) {
                toast.success("OTP verified successfully!");
                handleSubmit()
            } else {
                toast.error("Incorrect OTP. Try again.");
            }
        } catch (error) {
            console.error("Error during verifying otp : ", error);
            toast.error(`${error?.response?.data?.msg}`);
        } finally {
            setIsVerifyingOTP(false);
        }
    };

    useEffect(() => {
        const updatedErrors = { ...errors };

        if (clubname && errors.clubname) delete updatedErrors.clubname;
        if (nationality && errors.nationality) delete updatedErrors.nationality;
        // if (email && errors.email) delete updatedErrors.email;
        // if (password && errors.password) delete updatedErrors.password;
        // if (confirmPassword && errors.confirmPassword && password === confirmPassword) delete updatedErrors.confirmPassword;

        if (Object.keys(updatedErrors).length !== Object.keys(errors).length) {
            setErrors(updatedErrors);
        }
    }, [clubname, nationality]);


    return (
        <div className='min-h-screen flex flex-col items-center justify-center bg-cover py-10 overflow-hidden' style={{ backgroundImage: 'url("/assets/bg/Authbg.svg")' }}>
            <div className='flex justify-between w-full md:mb-0 mb-10'>
                <div className='w-[50%]'>
                    <button onClick={() => { window.location.href = '/' }} className=" cursor-pointer absolute top-5 left-5 flex items-center gap-2 text-white px-4 py-2 rounded-full">
                        <FontAwesomeIcon icon={faArrowLeft} />
                        <span >Back</span>
                    </button>
                </div>

                <div className='top-5 right-1 absolute'>
                    <GoogleTranslate />

                </div>
            </div>
            <div className='w-[90%] flex flex-col-reverse lg:flex-row items-center gap-10 text-white '>
                <div className='w-[100%] lg:w-[50%] relative'>
                    <h1 className='text-xl font-bold uppercase text-center translate-y-7 lg:translate-y-20 2xl:translate-y-24'>Welcome To Goaldex</h1>
                    <img src='/assets/others/clubsignup.svg' className='mx-auto scale-105' data-aos='flip-left' data-aos-duration='1500'></img>
                    <img src='/assets/others/Ball.svg' className='ball-spin w-[25%] absolute bottom-10 right-0 lg:hidden block' style={{ zIndex: 1 }} />
                </div>
                <div className='w-[100%] lg:w-[50%] relative'>
                    <div className='bg-white/5 lg:w-[90%] 2xl:w-[80%] 2xl:mx-auto p-7 lg:px-10 py-10 lg:py-10 2xl:py-20' data-aos='fade-down' data-aos-duration='1500'>
                        <h1 className='text-center text-3xl md:text-5xl 2xl:text-6xl' style={{ fontFamily: 'Sacramento' }}>Sign up</h1>
                        <div className='w-[100%] md:w-[90%] mx-auto mt-5 space-y-3'>

                            <input
                                type='text'
                                placeholder='Club Name'
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^[a-zA-Z]*$/.test(value)) {
                                        setClubname(value);
                                    }
                                }}
                                value={clubname}
                                className='w-[100%] bg-[#545454]/20 placeholder:text-white placeholder:font-semibold rounded outline-none py-2 px-3'
                            />
                            {errors.clubname && <p className="text-red-400 text-sm">{errors.clubname}</p>}

                            <input type='email' placeholder='Email Address'
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setEmail(value);

                                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                    setErrors((prev) => ({
                                        ...prev,
                                        email: value && !emailRegex.test(value.trim())
                                            ? "Invalid email format"
                                            : "",
                                    }));
                                }}
                                className='w-[100%] bg-[#545454]/20 placeholder:text-white placeholder:font-semibold rounded outline-none py-2 px-3'></input>
                            {errors.email && <p className="text-red-400 text-sm">{errors.email}</p>}

                            <select
                                className="w-full font-semibold bg-[#54545420] text-white rounded-md py-3 px-3 outline-none border border-transparent focus:border-white transition-all duration-200"
                                value={nationality}
                                onChange={(e) => setNationality(e.target.value)}
                            >
                                <option className="bg-black text-white" value="">
                                    Select a country
                                </option>
                                {CountryList.map((country, index) => (
                                    <option
                                        key={country.label}
                                        className="bg-black text-white"
                                        value={country.label}
                                    >
                                        {country.label} {country.country_flag}
                                    </option>
                                ))}
                            </select>
                            {errors.nationality && <p className="text-red-400 text-sm">{errors.nationality}</p>}

                            <div className='relative'>
                                <input type={showPassword ? 'text' : 'password'} placeholder='Create Password'
                                    value={password}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setPassword(value);

                                        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;
                                        setErrors((prev) => ({
                                            ...prev,
                                            password: value && !passwordRegex.test(value)
                                                ? "Password must be at least 8 characters with uppercase, lowercase, number & special character"
                                                : "",
                                        }));
                                    }}
                                    className='w-[100%] bg-[#545454]/20 placeholder:text-white placeholder:font-semibold rounded outline-none py-2 px-3'
                                />
                                <button
                                    type='button'
                                    onClick={togglePasswordVisibility}
                                    className='absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer'
                                >
                                    <FontAwesomeIcon
                                        icon={showPassword ? faEye : faEyeSlash}
                                        className='text-gray-500'
                                    />
                                </button>
                            </div>
                            {errors.password && <p className="text-red-400 text-sm">{errors.password}</p>}


                            <div className='relative'>
                                <input type={showConfirmPassword ? 'text' : 'password'} placeholder='Confirm Password'
                                    value={confirmPassword}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setConfirmPassword(value);

                                        setErrors((prev) => ({
                                            ...prev,
                                            confirmPassword:
                                                value && password && value !== password
                                                    ? "Passwords do not match"
                                                    : "",
                                        }));
                                    }}
                                    className='w-[100%] bg-[#545454]/20 placeholder:text-white placeholder:font-semibold rounded outline-none py-2 px-3'
                                />
                                <button type='button' onClick={toggleConfirmPassword} className='absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer'>
                                    <FontAwesomeIcon icon={showConfirmPassword ? faEye : faEyeSlash} className='text-gray-500' />
                                </button>
                                {passwordsMatch && (
                                    <div className='absolute right-10 top-1/2 transform -translate-y-1/2'>
                                        <FontAwesomeIcon icon={faCheckCircle} className='text-green-500' />
                                    </div>
                                )}
                            </div>
                            {errors.confirmPassword && <p className="text-red-400 text-sm">{errors.confirmPassword}</p>}

                        </div>
                        <div className='flex justify-center mt-5'>
                            <button onClick={handleSendOTP} className='border rounded-full flex items-center gap-2 py-[2px] pl-5 pr-[2px] cursor-pointer' disabled={isSendingOTP}>
                                <span>{isSendingOTP ? 'Sending OTP...' : 'Sign up'}</span>
                                <button className='w-8 h-8 rounded-full bg-white text-black grid place-content-center'>
                                    {isSendingOTP ? (
                                        <FontAwesomeIcon icon={faSpinner} spin />
                                    ) : (
                                        <FontAwesomeIcon icon={faArrowRight} />
                                    )}
                                </button>
                            </button>
                        </div>
                        <p className='font-semibold text-center mt-5'>Need Help With Login ? Support</p>
                        <p className="font-semibold text-center mt-5">
                            <span onClick={() => navigate("/club/login")} className=" cursor-pointer hover:underline">
                                Already have a club
                            </span>
                        </p>

                    </div>
                    <div data-aos='fade-right' data-aos-duration='1500'>
                        <img src='/assets/others/Ball.svg' className='ball-spin absolute -bottom-7 right-7 hidden lg:block' style={{ zIndex: 1 }} />
                    </div>
                </div>
            </div>
            {otpPopUp && (
                <div className="fixed inset-0 flex items-center justify-center bg-black/70 backdrop-blur-sm z-50">
                    <div className="bg-white/15 w-[90%] lg:w-[30%] p-7 lg:px-10 py-10 lg:py-5 2xl:py-10 text-white rounded-lg shadow-lg relative" data-aos="fade-down" data-aos-duration="1500">
                        <button onClick={() => setOtpPopUp(false)} className="absolute cursor-pointer top-3 right-3 text-white text-xl">✕</button>

                        <h1 className="text-center text-3xl md:text-5xl 2xl:text-6xl" style={{ fontFamily: "Sacramento" }}>
                            Verify Email
                        </h1>
                        <div className="w-[100%] md:w-[90%] mx-auto mt-4 2xl:mt-5 space-y-2 2xl:space-y-3">
                            <input
                                placeholder="Enter the OTP"
                                onChange={(e) => setOtp(e.target.value)}
                                className="w-full bg-[#545454]/20 placeholder:text-white placeholder:font-semibold rounded outline-none py-2 px-3"
                            />
                        </div>

                        <div className="flex justify-center mt-4 2xl:mt-5 gap-5">
                            <button onClick={handleResendOTP} disabled={isResendDisabled || isResendingOTP} className={`border rounded-full px-5 py-2 ${isResendDisabled || isResendingOTP ? "opacity-50 cursor-not-allowed" : ""}`}>
                                {isResendingOTP ? "Resending..." : `Resend ${resendTimer > 0 ? `(${resendTimer}s)` : ""}`}
                            </button>

                            <button onClick={handleVerifyOTP} className='bg-white text-black rounded-md px-5 py-2' disabled={isVerifyingOTP}>
                                {isVerifyingOTP ? "Verifying..." : "Verify"}
                            </button>
                        </div>
                    </div>
                </div >
            )}
        </div>
    )
}
